module.exports = __webpack_public_path__ + "img/book_01.ef829c11.jpg";